import { useState, useEffect } from 'react';
import { BatteryHorizIcon, ElecLine, MeterIcon, PcsIcon, PvIcon, DcdcIcon, IconLabel } from '../service/SvgIcons';
import { ObixUtil } from '../service/ObixUtil';

export function SingleLineSvgVietnam(props) {
    // props.objmap
    // props.site
    // props.siteInfo
    const iw = 75;  // icon width
    const ih = 75;  // icon height
    const fs = 24;  // font size

    const ix0 = 125;
    const ix1 = 380;  // pcs 위치
    const ix2 = 820;
    //const iy0 = 50;
    const iy1 = 500;  // pcs 위치
    //const iy2 = 385;
    const ixp = (ix1 + ix2)/2 - 0;
    const iyp = iy1-150;  // dcdc1 y
    const iyp2 = iyp-iw-fs*3;  // dcdc2 y
    const iyp3 = iyp2-iw-fs*3;  // dcdc3 y
    const jx = ixp-80;  // joint x

    const [pcsObj, setPcsObj] = useState(null);
    const [pv1Obj, setPv1Obj] = useState(null);
    const [pv2Obj, setPv2Obj] = useState(null);
    const [pv3Obj, setPv3Obj] = useState(null);
    const [batObj, setBatObj] = useState(null);
    const [meterObj, setMeterObj] = useState(null);

    useEffect(() => {
        //console.dir(props.objmap);
        if (!props?.objmap) return;
        setPcsObj(props.objmap.get('pcs/11/pcs'));
        setPv1Obj(props.objmap.get('pv1/11/inverter'));
        setPv2Obj(props.objmap.get('pv2/11/inverter'));
        setPv3Obj(props.objmap.get('pv3/11/inverter'));
        setBatObj(props.objmap.get('bms/1/bms'));
        //setMeterObj(props.objmap.get('meter/1/meter/ch1'));
    }, [props.objmap]);

    return (
        <svg width="100%" height="100%" viewBox="0 0 1024 726">
            <g>
                <ElecLine path={[ix1, iy1+ih/2, ix0+iw, iy1+ih/2]} obj={pcsObj} power="+power"/> {/* Meter - PCS */}
                <ElecLine path={[jx, iy1+ih/2, ix1+iw, iy1+ih/2]} obj={pcsObj} power="-power" cb="-"/> {/* PCS - PVJoint */}
                <PcsIcon x={ix1} y={iy1} w={iw} h={ih}/>
                <IconLabel x={ix1} y={iy1+ih+fs} h={fs} type="ac" obj={pcsObj}/>

                <ElecLine path={[ix2, iy1+ih/2, jx, iy1+ih/2]} obj={batObj} power="-dcPower"/> {/* Bat - PVJoint */}
                <BatteryHorizIcon x={ix2} y={iy1} w={iw} h={ih}/>
                <IconLabel x={ix2} y={iy1+ih+fs} h={fs} type="bat" obj={batObj}/>

                <DcdcIcon x={ixp+iw/2} y={iyp} w={iw} h={ih}/>
                <IconLabel x={ixp+iw/2} y={iyp+ih+fs} h={fs} type="dcout" obj={pv1Obj}/>
                <PvIcon x={ix2} y={iyp} w={iw} h={ih}/>
                <IconLabel x={ix2} y={iyp+ih+fs} h={fs} type="dcin" obj={pv1Obj}/>
                <ElecLine path={[ixp+iw/2, iyp+ih/2, jx, iyp+ih/2, jx, iy1+ih/2]} obj={pv1Obj} power="+power" cb="outMcClosed"/>
                <ElecLine path={[ix2, iyp+ih/2, ixp+iw/2+iw, iyp+ih/2]} obj={pv1Obj} power="+power" cb="inMcClosed"/>

                <DcdcIcon x={ixp+iw/2} y={iyp2} w={iw} h={ih}/>
                <IconLabel x={ixp+iw/2} y={iyp2+ih+fs} h={fs} type="dcout" obj={pv2Obj}/>
                <PvIcon x={ix2} y={iyp2} w={iw} h={ih}/>
                <IconLabel x={ix2} y={iyp2+ih+fs} h={fs} type="dcin" obj={pv2Obj}/>
                <ElecLine path={[ixp+iw/2, iyp2+ih/2, jx, iyp2+ih/2, jx, iy1+ih/2]} obj={pv2Obj} power="+power" cb="outMcClosed"/>
                <ElecLine path={[ix2, iyp2+ih/2, ixp+iw/2+iw, iyp2+ih/2]} obj={pv2Obj} power="+power" cb="inMcClosed"/>

                <DcdcIcon x={ixp+iw/2} y={iyp3} w={iw} h={ih}/>
                <IconLabel x={ixp+iw/2} y={iyp3+ih+fs} h={fs} type="dcout" obj={pv3Obj}/>
                <PvIcon x={ix2} y={iyp3} w={iw} h={ih}/>
                <IconLabel x={ix2} y={iyp3+ih+fs} h={fs} type="dcin" obj={pv3Obj}/>
                <ElecLine path={[ixp+iw/2, iyp3+ih/2, jx, iyp3+ih/2, jx, iy1+ih/2]} obj={pv3Obj} power="+power" cb="outMcClosed"/>
                <ElecLine path={[ix2, iyp3+ih/2, ixp+iw/2+iw, iyp3+ih/2]} obj={pv3Obj} power="+power" cb="inMcClosed"/>

                <MeterIcon x={ix0} y={iy1} w={iw} h={ih}/>
            </g>
        </svg>
    );
}
